import React, { useEffect, useState } from 'react'
import SingleSignOnSideBar from '../Components/SingleSignOnSideBar'
import Header from '../Components/Header'
import Loader from "../Components/Common/Loader";
import CardComp from './CardComp'
import PackUpdateNew from './PackUpdateNew'
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { AESDecryption, AESEncryption, allTrim, ApiResDecrypt, decriptResponse, decryptData, encyptPayload, getSearchParameters, nameFirstLetter, startTrimString } from '../CommonMethhods/CommonMethods'
import { DELETE_DOCUMENT, SERVICES, telecallerImage } from '../Configuration/Telecaller_URl'
import { Button, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import JSZip from 'jszip'
import RoundLoader from '../Components/Common/RoundRingLoader'
import { CommonDate } from '../CommonMethhods/DateFunction'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../CommonMethhods/axiosInstance';
import axios from 'axios';

const TelecallerUpdated = () => {

    const [clientDetails, setClientDetails] = useState({})
    const [table, setTable] = useState({ lead: false, pack: false })
    const [documentVal, setDocumentVal] = useState({ digilocker: false, bav: false, signature: false, selfie: false })
    const [loader, setLoader] = useState(false);
    const [filterModal, setFilterModal] = useState(false);
    const [modalData, setModalData] = useState("");
    const [globalModal, setGlobalModal] = useState({ modal: false, update: "", value: null });
    const userType = localStorage.getItem("userType").toLowerCase();
    const [documentType, setDocumentType] = useState("");
    const [documentTypeError, setDocumentTypeError] = useState("");
    const identifyFlag = sessionStorage.getItem("identifyFlag");

    console.log("usertype", userType)
    const numberchema = Yup.object().shape({
        number: Yup.string()

            // .required("Please enter mobile number (or) reference No.*")
            // .matches(
            //     /^[A-Za-z0-9]/,
            //     "Number Or RefNO will be 10 to 20 digits"
            // ),
            // .required("Please enter reference No.*")
            // .matches( /^(?!\d+$)[A-Za-z0-9]{10,20}$/,
            //     "RefNo should be 10 to 20 alphanumeric characters."
            // )
            .when([], {
                is: () => userType == "capital_markets",  // If userType is "Capital market"
                then: Yup.string()
                    .required("Please enter mobile number (or) reference No.*")
                    .matches(
                        /^[A-Za-z0-9]/,
                        "Number Or RefNO will be 10 to 20 digits"
                    ),
                otherwise: Yup.string()
                    .required("Please enter reference No.*")
                    .matches(/^(?!\d+$)[A-Za-z0-9]{10,20}$/,
                        "RefNo should be 10 to 20 alphanumeric characters."
                    )
            })

    });



    const schema = Yup.object().shape({
        dob: Yup.string()
            .required("Please Enter Your DOB")


    });

    const schemaEmail = Yup.object().shape({
        email: Yup.string()
            .required("Please Enter Your Email")
            .matches(
                /^\w+([\.-]?\w+)*@[A-Za-z]{1}\w+([\.-]?\w+)*(\.[A-Za-z]{1}\w{1,5})+$/,
                "Plese Input valid Email"
            )

    });
    const schemaGender = Yup.object().shape({
        gender: Yup.string()
            .required("Select Gender")
    });





    const schemaFname = Yup.object().shape({
        fname: Yup.string().required("Enter Your Father Name").matches(/^((\b[A-Za-z]{1,40}\b)\s*){1,6}$/, "Please Enter Valid Father Name")
    });

    const { register: registerEmail, handleSubmit: handleSubmitEmail, formState: { errors: emailErrors }, setErrorEmail } = useForm({
        mode: "onChange",
        resolver: yupResolver(schemaEmail),
    });

    const { register: registerGender, handleSubmit: handleSubmitGender, reset: resetGendar, formState: { errors: genderErrors }, setErrorGender } = useForm({
        mode: "onChange",
        resolver: yupResolver(schemaGender),
    });

    const { register: registerFname, handleSubmit: handleSubmitFname, reset: resetFatherName, formState: { errors: fnameErrors }, setErrorFname } = useForm({
        mode: "onChange",
        resolver: yupResolver(schemaFname),
    });

    const { register, handleSubmit, formState: { errors }, reset: resetDob, setError, getValues } = useForm({
        mode: "onChange",
        resolver: yupResolver(schema),
    });


    const {
        register: regesterNumber,
        handleSubmit: SubmitNumber,
        formState: { errors: numberError },
        setValue: setNumberVal,
        getValues: getNumberValues,
        clearErrors
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(numberchema),
    });



    const schemaFilter = Yup.object().shape({
        numberFilter: Yup.string()
            .notRequired(),
        fromDate: Yup.string().required("Enter From Date"),
        toDate: Yup.string().required("Enter To Date"),
        kraStatus: Yup.string().required("Select your KRA status"),
        appStatus: Yup.string().required("Select your App status")
    });
    const { register: regesterFilter, handleSubmit: handleFilterSubmit, formState: { errors: filterErrors }, setValue: setFilterValue } = useForm({
        mode: "onChange",
        resolver: yupResolver(schemaFilter),
    });
    const resetModal = () => {
        setFilterValue("numberFilter", "");
        setFilterValue("fromDate", "");
        setFilterValue("toDate", "");
    }
    useEffect(() => {
        const urlParams = getSearchParameters();
        // console.log(ApiResDecrypt(urlParams.mobileref),"urlParams");
        if (urlParams.mobileref) {
            let EncNumber = AESDecryption(urlParams.mobileref);
            EncNumber = EncNumber.replace(/"/g, '');

            if (EncNumber) {
                function isAlphanumeric(str) {
                    return str.match(/^[a-zA-Z0-9]+$/) !== null;
                }
                let isANumber = isAlphanumeric(EncNumber);
                if (!isANumber) {
                    toast.error("Invalid search parameter");
                } else {
                    setNumberVal("number", EncNumber);
                    SubmitNumber(GetData)();
                }
            }
        }

    }, []);
    const [rejectionData, setRejectionData] = useState([])
    const [submittedData, setSubmittedData] = useState([])
    const [createdData, setCreatedData] = useState([])
    const [filterData, setFilterData] = useState(null)
    const [hgsTable, setHgsTable] = useState({ reject: false, submit: false, activated: false })
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const navigate = useNavigate();
    const [session, setSession] = useState(false);
    const [aadherPan, setAadherPan] = useState(false);

    const filterApplication = async (data) => {
        console.log(data, "filtar");
        setFilterData(data)
        setSmallLoaderExcel(true)
        const fromDate = data.fromDate ? data.fromDate.split("-").reverse().join("-") : "";
        const toDate = data.toDate ? data.toDate.split("-").reverse().join("-") : "";
        let payload = {
            userName: "",
            mobile: data.numberFilter || "",
            fromDate: fromDate,
            toDate: toDate,
            kraStatus: data.kraStatus || "",
            status: data.appStatus || "",
            fileType: "grid",
            telecallerId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            pageNo: -1,
            pageSize: 10,
        }
        console.log(payload, "payload");

        let encPayload = AESEncryption(payload)
        console.log(encPayload, "encPayload");

        try {
            const response = await axiosInstance.post(
                `${SERVICES.HGSDashboardOverAllBal}`,
                encPayload,
            );
            let data = response.data;
            let decResData = ApiResDecrypt(data)
            console.log(decResData, "decResData");
            if (decResData?.status == 0) {
                console.log(decResData, "decResData");
                setRejectionData([]);
                setSubmittedData([]);
                setCreatedData([]);

                // debugger
                if (decResData.data.HGSDashboardRes !== undefined) {
                    setHgsTable({ reject: false, submit: true, activated: false })
                    setRejectionData([])
                    setSubmittedData((prev) => {
                        return [...prev, ...decResData?.data.HGSDashboardRes];
                    })
                }
                // debugger
                if (decResData.data.HGSRejectedDashboardRes !== undefined) {
                    setHgsTable({ reject: true, submit: false, activated: false })
                    setSubmittedData([])
                    setRejectionData((prev) => {
                        return [
                            ...prev,
                            ...decResData?.data.HGSRejectedDashboardRes,
                        ];
                    })
                }
                if (decResData.data.AccountCreatedUsersRes !== undefined) {
                    setHgsTable({ reject: false, submit: false, activated: true })
                    // setSubmittedData([])
                    setCreatedData((prev) => {
                        return [
                            ...prev, ...decResData?.data.AccountCreatedUsersRes,
                        ];
                    })
                }
                // if (fileType == "excel") {
                //     window.open(decResData?.data, "_self", "noopener,noreferrer");
                //     toast.success("File Download Successfully");
                // }
                setFilterModal(false)
            } else {
                // console.log(decResData.message);
                setHgsTable({ reject: false, submit: false, activated: false })
                setFilterModal(false)
                toast.error(decResData.message)
            }
        } catch (err) {
            if (err.message) {
                toast.error(err.message);
            }
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        } finally {
            setSmallLoaderExcel(false)
            // setHgsTable({ reject: false, submit: false, activated: false })
        }

    }
    console.log(hgsTable, "hgsTable");
    const handleOnClick = () => {
        filterApplication(filterData, "excel");
    };

    const handleBoxClick = (type, value) => {
        let status = '';
        // setFilterValue("numberFilter", "");
        // setFilterValue("fromDate", "");
        // setFilterValue("toDate", "");
        switch (type) {
            case 'Submitted':
                status = 'submitted';
                break;
            case 'Rejected':
                status = 'rejected';
                break;
            case 'Opened':
                status = 'onl';
                break;
            default:
                status = '';
        }

        filterApplication({ appStatus: status });
    };
    const editRejected = (data) => {
        // let numberEnc=encyptPayload(data.refIdOrNumber);
        // console.log(numberEnc,"numberEnc");
        // console.log(AESDecryption(numberEnc),"numberEnc");

        // return

        window.open(
            `${window.location.origin}/telecallerPage?mobileref=${encyptPayload(data.refIdOrNumber)}`
        );
        // if (userType == "capital_markets") {
        //     window.open(
        //         `${window.location.origin}/telecallerPage?mobileref=${data.mobile}`
        //     );
        // } else {
        //     window.open(
        //         `${window.location.origin}/telecallerPage?mobileref=${data.refID}`
        //     );
        // }

    }
    const sessionExpired = () => {
        setSession(false);
        localStorage.clear("");
        navigate("/");
    };
    const onlDataShow = (createdData) => {
        return (
            createdData &&
            createdData.map((item, key) => {
                return (
                    <tr key={key}>
                        <td>
                            {item.mobileMasked === "" || undefined || null
                                ? "-"
                                : item.mobileMasked}
                        </td>
                        <td>{item.cName === "" || undefined || null ? "-" : item.cName}</td>

                        <td>
                            {item.packAmount === "" || undefined || null
                                ? "-"
                                : item.packAmount}
                        </td>
                        <td>
                            {item.kraFlag === "" || undefined || null ? "-" : item.kraFlag}
                        </td>
                        <td>
                            {item.IPVFlag === "" || undefined || null ? "-" : item.IPVFlag}
                        </td>
                        <td>
                            {item.submittedOn === "" || undefined || null
                                ? "-"
                                : item.submittedOn}
                        </td>
                        <td>{item.onlId === "" || undefined || null ? "-" : item.onlId}</td>
                        <td>
                            {item.accountActivated === "" || undefined || null
                                ? "-"
                                : item.accountActivated}
                        </td>
                    </tr>
                );
            })
        );
    };
    const showTeleTableData = (submittedData = []) => {
        console.log(submittedData, "submitted");
        return (
            submittedData &&
            submittedData.map((item, key) => {
                return (
                    <tr key={key}>
                        <td>
                            {item.mobileMasked === "" || undefined || null
                                ? "-"
                                : item.mobileMasked}
                        </td>
                        <td>{item.cName === "" || undefined || null ? "-" : item.cName}</td>
                        <td>
                            {item.packAmount === "" || undefined || null
                                ? "-"
                                : item.packAmount}
                        </td>
                        <td>
                            {item.kraFlag === "" || undefined || null ? "-" : item.kraFlag}
                        </td>
                        <td>
                            {item.IPVFlag === "" || undefined || null ? "-" : item.IPVFlag}
                        </td>
                        <td>
                            {item.submittedOn === "" || undefined || null
                                ? "-"
                                : item.submittedOn}
                        </td>
                    </tr>
                );
            })
        );
    };

    const RejectTableShow = (rejectedData = []) => {
        console.log(rejectedData, "rejectedData");

        return (
            rejectedData &&
            rejectedData.map((item, key) => {
                return (
                    <tr key={key}>
                        <td>
                            {item.mobileMasked === "" || undefined || null
                                ? "-"
                                : item.mobileMasked}
                        </td>
                        <td>{item.cName === "" || undefined || null ? "-" : item.cName}</td>
                        <td>
                            {item.packAmount === "" || undefined || null
                                ? "-"
                                : item.packAmount}
                        </td>
                        <td>
                            {item.kraFlag === "" || undefined || null ? "-" : item.kraFlag}
                        </td>
                        <td>
                            {item.IPVFlag === "" || undefined || null ? "-" : item.IPVFlag}
                        </td>

                        <td>
                            {item.submittedOn === "" || undefined || null
                                ? "-"
                                : item.submittedOn}
                        </td>
                        <td>
                            {item.rejectedOn === "" || undefined || null
                                ? "-"
                                : item.rejectedOn}
                        </td>
                        <td>
                            {item.rejectedReason === "" || undefined || null
                                ? "-"
                                : item.rejectedReason}
                        </td>
                        <td>
                            {item.rejectedReason === "" || undefined || null ? (
                                "-"
                            ) : (
                                <span
                                    className="icon-Edit edit-icon"
                                    onClick={() => editRejected(item)}
                                ></span>
                            )}
                        </td>
                    </tr>
                );
            })
        );
    };
    const [existNumber, setExistNumber] = useState(false)
    const [noData, setNoData] = useState("")
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [loaderMain, setLoaderMain] = useState({ get: false, dob: false, gender: false, fname: false, email: false })

    const GetData = async (value) => {
        setLoader(true)
        setIsButtonDisabled(true);
        setLoaderMain({ get: true, dob: false, gender: false, fname: false, email: false })
        const userNumber = value?.number || localStorage.getItem("teleUserNumber");

        // Only set teleUserNumber if a valid number is provided
        if (userNumber) {
            localStorage.setItem("teleUserNumber", userNumber);
        }
        // setFilterModal(true)
        let clientPayLoad = {
            mobile: userNumber,
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
        };
        console.log(clientPayLoad, "clientPayLoad");
        let encPayload = AESEncryption(clientPayLoad)
        try {
            const response = await axiosInstance.post(
                `${SERVICES.CLIENT_DETAILSV2}`,
                encPayload,
            );
            const data = await response.data;
            let adminResponse = ApiResDecrypt(data);
            console.log(adminResponse, "adminResponse");
            // debugger
            if (adminResponse.status == 0) {
                // localStorage.setItem("teleUserNumber", value?.number)
                if (adminResponse.data.leadDetails !== null) {

                    setTable({ lead: true, pack: false })
                    setClientDetails(adminResponse.data.leadDetails)

                }
                if (adminResponse.data.packUpgrade !== null) {
                    setTable({ lead: false, pack: true })
                    setClientDetails(adminResponse.data.packUpgrade)
                }

                const documentStatus = adminResponse.data.documentStatus;

                setDocumentVal({
                    bav: documentStatus?.isBankValidated || false,
                    signature: documentStatus?.isSignature || false,
                    selfie: documentStatus?.isSelfie || false,
                    digilocker: documentStatus?.isDigilocker || false,
                });


                if (adminResponse.data == "Another Telecaller user is working on this application") {
                    setTable({ lead: false, pack: false })
                    setExistNumber(true);
                    return;
                }
                if (adminResponse.data?.leadDetails?.IsAadharPanSeeded == false) {
                    setAadherPan(true);
                }
                // else {
                //     setAadherPan(false);
                // }
            } else {
                setNoData(adminResponse.message)
                setTable({ lead: false, pack: false });
            }
        } catch (err) {
            console.log(err);
            // console.log(err);
            // setNoData("Something went wrong");
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
                setNoData("Something went wrong");
            }

            setTable({ lead: false, pack: false });
        } finally {
            // setAadherPan(false);
            setLoaderMain({ get: false, dob: false, gender: false, fname: false, email: false })
            setLoader(false)
            setTimeout(() => {
                setIsButtonDisabled(false);
            }, 2000);
        }
    }
    const editApplication = async () => {
        let editApp = {
            mobile: clientDetails.mobile,
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            ekycrej: clientDetails.isRejected == "" ? false : true,
        };
        let encPayload = AESEncryption(editApp);
        try {
            const response = await axiosInstance.post(
                `${SERVICES.EDIT_APPLICATION}`,
                encPayload,
            );
            const data = await response.data;
            let editResponse = ApiResDecrypt(data);
            if (editResponse.data !== "" || editResponse.data !== null) {
                window.open(editResponse.data);
            }
        } catch (err) {
            if (err.request.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    }
    const updateAll = () => {
        if (globalModal.update === "DOB") {
            const originalDate = new Date(globalModal.value.dob);
            const day = String(originalDate.getDate()).padStart(2, '0');
            const month = String(originalDate.getMonth() + 1).padStart(2, '0');
            const year = originalDate.getFullYear();
            const formattedDob = `${day}-${month}-${year}`;

            if (formattedDob === clientDetails.dob) {
                toast.error("New DOB cannot be the same as the current DOB");
            } else {
                setLoaderMain({ get: false, dob: true, gender: false, fname: false, email: false });
                commonUpdateFun('dob', formattedDob);
            }
        } else if (globalModal.update === "Gender") {
            if (globalModal.value.gender === clientDetails.genderView) {
                toast.error("New gender cannot be the same as the current gender");
            } else {
                setLoaderMain({ get: false, dob: false, gender: true, fname: false, email: false });
                commonUpdateFun('gender', globalModal.value.gender);
            }
        } else if (globalModal.update === "Father Name") {
            if (globalModal.value.fname === clientDetails.fatherName) {
                toast.error("New Father Name cannot be the same as the current Father Name");
            } else {
                setLoaderMain({ get: false, dob: false, gender: false, fname: true, email: false });
                commonUpdateFun('fatherName', globalModal.value.fname);
            }
        }

        setGlobalModal({ modal: false, update: "", value: null });
    };

    const updateDob = (value) => {
        setGlobalModal({ modal: true, update: "DOB", value });
        setModalData("DOB");
    };

    const updateGender = (value) => {
        setGlobalModal({ modal: true, update: "Gender", value });
        setModalData("Gender");
    };

    const updateFname = (value) => {
        setGlobalModal({ modal: true, update: "Father Name", value });
        setModalData("Father Name");
    };

    const commonUpdateFun = async (field, value) => {
        let updateObject = {
            mobile: clientDetails.mobile,
            gender: clientDetails.genderView,
            dob: clientDetails.dob,
            packtype: clientDetails.packType,
            packpayinfo: clientDetails.packAmount,
            userName: clientDetails.cName,
            transRefNo: clientDetails?.transRefNo || "",
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            fatherName: clientDetails.fatherName,
            [field]: value, // Dynamically set the field to update
        };

        let encPayload = AESEncryption(updateObject);
        try {
            const response = await axiosInstance.post(
                `${SERVICES.UPDATE_DOB_TELECALLER}`,
                encPayload,
            );
            const data = await response.data;
            let updateDobResReq = ApiResDecrypt(data);
            if (updateDobResReq.status === 0) {
                toast.success(updateDobResReq.data.message);
                resetDob({ dob: "" });
                resetFatherName({ fname: "" });
                resetGendar({ gender: "" });
                GetData();
            } else {
                toast.error("Update failed");
            }
        } catch (err) {
            toast.error("An error occurred during the update");
        } finally {
            setLoaderMain({ get: false, dob: false, gender: false, fname: false, email: false });
        }
    };

    const [otpInput, setOtpInput] = useState(false)
    const updateEmail = (value) => {
        console.log(value, "email");
        if (value.email === clientDetails.emailId) {
            toast.error("New email cannot be the same as the current email");
        } else {
            setLoaderMain({ get: false, dob: false, gender: false, fname: false, email: true })
            setModalData("Email");
            getEmailOtp(value.email);
        }

    }
    const [emailData, setEmailData] = useState(null)
    const getEmailOtp = async (email) => {
        let sendEmail = {
            emailId: email,
            customerName: clientDetails.cName,
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            mobileNo: clientDetails.mobile,
        };
        console.log(sendEmail, "sendEmail");
        let encPayload = AESEncryption(sendEmail);
        try {
            const response = await axiosInstance.post(
                `${SERVICES.SEND_EMAIL_OTP}`,
                encPayload,
            );
            const data = await response.data;
            let emailotpverifyRes = ApiResDecrypt(data);
            console.log(emailotpverifyRes, "emailotpverifyRes");
            if (emailotpverifyRes.status == 0) {
                if (emailotpverifyRes.data.message == "This Email Id is already registered with us.") {
                    toast.error(emailotpverifyRes.data.message)
                    setOtpInput(false)
                } else {
                    setOtpInput(true)
                    localStorage.setItem("ReqEmail", email);
                    toast.success(emailotpverifyRes.data.message)
                    setEmailData(emailotpverifyRes.data)
                }
            } else {
                setOtpInput(false)
            }
        } catch (err) {

        } finally {
            setLoaderMain({ get: false, dob: false, gender: false, fname: false, email: false })
        }
    };
    const EmailOtpValidation = (event) => {
        event.target.value = event.target.value.replace(/[^0-9]/g, "");
    };
    const emailVerification = async (e) => {
        console.log(e.target.value);
        if (e.target.value.length == 4) {
            let emailverified = {
                emailID: localStorage.getItem("ReqEmail"),
                otp: e.target.value,
                uqId: emailData.uqid,
                mobileNo: clientDetails.mobile,
                userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            };
            console.log(emailverified, "emailverified");
            // return
            let encPayload = AESEncryption(emailverified);
            try {
                const response = await axiosInstance.post(
                    `${SERVICES.EMAIL_VALIDATED}`,
                    encPayload,

                );
                const data = await response.data;
                let emailverifRes = ApiResDecrypt(data);
                if (emailverifRes.status == 0) {
                    if (emailverifRes.data.message == "Otp Validated") {
                        toast.success(emailverifRes.data.message);
                        setOtpInput(false)
                    } else {
                        toast.error(emailverifRes.data.message);
                    }
                } else {
                    toast.error(emailverifRes.message);
                    if (emailverifRes.message == "Invalid Otp") {

                    }
                }
            } catch (err) {
                if (err?.request?.status == "401") {
                } else {
                }
            }
        }

    };

    let imgList = [
        // {`${telecallerImage.all}`, monthly, today },
        { all: "All", monthly: "Monthly", today: "Today" }
    ];
    useEffect(() => {
        Dashboard();
    }, []);
    const [hgsData, setHgsData] = useState(null)
    const Dashboard = async () => {
        let payload = {
            telecallerId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
        }
        let encPayload = AESEncryption(payload)
        try {
            const dashboardRes = await axiosInstance.post(
                SERVICES.HGSTableWiseDashboardV2,
                encPayload,
            );
            let res = dashboardRes.data;
            let decResData = ApiResDecrypt(res)
            console.log(decResData, "decResData");
            if (decResData.status == 0) {
                setHgsData(decResData.data)

            } else {
                toast.error(decResData?.message);
            }
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const downloadFiles = async () => {
        let downloadRequest = {
            mobile: clientDetails.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            pageSize: 0,
            pageNo: 0,
        };

        let encPayload = AESEncryption(downloadRequest);

        try {
            const response = await axiosInstance.post(
                `${SERVICES.GetAllDocuments}`,
                encPayload,
            );

            const { data } = response;
            let downloadWpDocRes = ApiResDecrypt(data);
            if (downloadWpDocRes.status == 1) {
                toast.error(downloadWpDocRes.message);
            }
            const zip = new JSZip();
            const promises = [];
            downloadWpDocRes.data.docList.forEach((doc) => {
                const fileName = doc.docName.split("/").pop();
                promises.push(
                    axios
                        .get(doc.docPath, { responseType: "blob" })
                        .then((downloadWpDocRes) =>
                            zip.file(fileName, downloadWpDocRes.data)
                        )
                );
            });
            Promise.allSettled(promises)
                .then(() => {
                    zip.generateAsync({ type: "blob" }).then((blob) => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "files.zip";
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                })
                .catch((error) => console.error("Error downloading files:", error));
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };
    const sendWpMessage = async () => {
        let messageRequest = {
            mobile: clientDetails.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            customerName: clientDetails.cName || "Customer",
        };
        let encPayload = AESEncryption(messageRequest);

        try {
            const response = await axiosInstance.post(
                `${SERVICES.WhatsappMSGToClient}`,
                encPayload,
            );
            const data = await response.data;
            let sendWpMRes = ApiResDecrypt(data);
            if (sendWpMRes.status == 0) {
                if (sendWpMRes.data.msg == "SMS sent successfully") {
                    toast.success(sendWpMRes.data.msg);
                }
                if (sendWpMRes.data.msg == "Max limit reached for sms") {
                    document.getElementById("wpMs").disabled = true;
                    toast.error(sendWpMRes.data.msg);
                } else {
                    document.getElementById("wpMs").disabled = false;
                }
            } else {
                console.log(sendWpMRes, "error");
                toast.error(sendWpMRes.message);
            }
            console.log(data);
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const sendWpMessageRgCC = async () => {
        let messageRequest = {
            mobile: clientDetails.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            customerName: clientDetails.cName || "Customer",
        };
        console.log(messageRequest, "messageRequest");

        let encPayload = AESEncryption(messageRequest);

        try {
            const response = await axiosInstance.post(
                `${SERVICES.Whatsapp_send}`,
                encPayload,
            );
            const data = await response.data;
            let sendWpMRes = ApiResDecrypt(data);
            if (sendWpMRes.status == 0) {
                if (sendWpMRes.data.msg == "SMS sent successfully") {
                    toast.success(sendWpMRes.data.msg);
                }
                if (sendWpMRes.data.msg == "Max limit reached for sms") {
                    document.getElementById("wpMs").disabled = true;
                    toast.error(sendWpMRes.data.msg);
                } else {
                    document.getElementById("wpMs").disabled = false;
                }
            } else {
                console.log(sendWpMRes, "error");
                toast.error(sendWpMRes.message);
            }
            console.log(data);
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const downloadFilesRgCC = async () => {
        let downloadRequest = {
            mobile: clientDetails.mobile || localStorage.getItem("teleUserNumber"),
            userId: localStorage.getItem("userName"),
            pageSize: 0,
            pageNo: 0,
        };

        console.log(downloadRequest, "downloadRequest");

        let encPayload = AESEncryption(downloadRequest);

        try {
            const response = await axiosInstance.post(
                `${SERVICES.GetAllDocs_Rgcc}`,
                encPayload,
            );

            const { data } = response;
            let downloadWpDocRes = ApiResDecrypt(data);
            if (downloadWpDocRes.status == 1) {
                toast.error(downloadWpDocRes.message);
            }
            const zip = new JSZip();
            const promises = [];
            downloadWpDocRes.data.docList.forEach((doc) => {
                const fileName = doc.docName.split("/").pop();
                promises.push(
                    axios
                        .get(doc.docPath, { responseType: "blob" })
                        .then((downloadWpDocRes) =>
                            zip.file(fileName, downloadWpDocRes.data)
                        )
                );
            });
            Promise.allSettled(promises)
                .then(() => {
                    zip.generateAsync({ type: "blob" }).then((blob) => {
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "files.zip";
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                    });
                })
                .catch((error) => console.error("Error downloading files:", error));
        } catch (err) {
            if (err?.request?.status == "401") {
                setSession(true);
            } else {
                setSession(false);
            }
        }
    };

    const allowedUserTypes = ["hgs", "bajaj", "capital_markets", "iba", "dr.itm"];
    const allowedUserTypesRgCC = ["regional call centre"];
    const noDataMessage = "No Data Found";
    const shouldShowButtons = (allowedUserTypes.includes(userType) && table.lead) || (userType === "capital_markets" && noData === noDataMessage);
    const showRegCCButtons = (allowedUserTypesRgCC.includes(userType) && table.lead) || (userType === "regional call centre" && noData === noDataMessage);

    const maskNumber = (mobile) => {
        let mobileDigit = mobile.split("")
        mobileDigit = mobileDigit.map((digits, index) => index < mobileDigit.length - 4 ? '*' : digits);
        return mobileDigit.join("")
    };

    const emailChange = (e) => {
        // console.log(e.target.value);
        if (e.target.value !== null || e.target.value !== "") {
            setOtpInput(false)
        }

    }


    const handleStepChange = (event) => {
        console.log("Selected Step:", event.target.value);

        setDocumentType(event.target.value);
        setDocumentTypeError("");

        console.log("Updated:", event.target.value);
    };


    useEffect(() => {
        // console.log("documentType updated:", documentType);
    }, [documentType]);



    const [isDeleting, setIsDeleting] = useState(false);

    const deleteDocumentold = async () => {
        if (isDeleting) return; // Prevent multiple clicks

        if (!documentType) {
            setDocumentTypeError("Please select a step.");
            return;
        }

        setDocumentTypeError("");
        setIsDeleting(true);

        let type = "";

        if (documentType === "Digilocker") {
            type = "Digilocker";
        } else if (documentType === "BAV") {
            type = "Bank";
        } else if (documentType === "Signature") {
            type = "Signature";
        } else if (documentType === "Selfie") {
            type = "Photograph";
        }

        const deleteDocumentPayload = {
            id: clientDetails.id,
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            pan: clientDetails.pan,
            docDef: type
        };

        const encPayload = AESEncryption(deleteDocumentPayload);

        try {
            const response = await axiosInstance.post(
                DELETE_DOCUMENT.Deletedocument,
                encPayload
            );

            const data = response.data;
            const editResponse = ApiResDecrypt(data);

            if (editResponse.status === 0) {
                setDocumentType("");
                toast.success(editResponse.data);
                GetData();
            } else {
                setDocumentType("");
                GetData();
                toast.error(editResponse.message);
            }
        } catch (err) {
            toast.error("Something went wrong.");
        } finally {
            setIsDeleting(false);
        }
    };



    const deleteDocument = async () => {
        if (isDeleting) return; // Prevent multiple clicks

        if (!documentType) {
            setDocumentTypeError("Please select a step.");
            return;
        }

        setDocumentTypeError("");
        setIsDeleting(true);

        let type = "";
        if (documentType === "Digilocker") {
            type = "Digilocker";
        } else if (documentType === "BAV") {
            type = "Bank";
        } else if (documentType === "Signature") {
            type = "Signature";
        } else if (documentType === "Selfie") {
            type = "Photograph";
        }

        const deleteDocumentPayload = {
            id: clientDetails.id,
            userId: identifyFlag ? localStorage.getItem("partnerUserId") : localStorage.getItem("userId"),
            pan: clientDetails.pan,
            docDef: type
        };

        const encPayload = AESEncryption(deleteDocumentPayload);
        try {
            const response = await axiosInstance.post(
                `${DELETE_DOCUMENT.Deletedocument}`,
                encPayload,
            );
            const data = response.data;
            const editResponse = ApiResDecrypt(data);

            if (editResponse.status === 0) {
                setDocumentType("");
                toast.success(editResponse.data);
                GetData();
            } else {
                setDocumentType("");
                GetData();
                toast.error(editResponse.message);
            }
        } catch (err) {
            toast.error("Something went wrong.");
        } finally {
            setIsDeleting(false);
        }
    }


    return (
        <div>
            <Header portal={"TELECALLER"} />
            <SingleSignOnSideBar />
            <main id="main-content" className="telecallerDash">
                <div className="telecaller">
                    <div className="card-box">

                        <div className="title-section">
                            <h2 className="card-title">Lead Dashboard</h2>
                            {shouldShowButtons &&
                                <div className='icons'>
                                    <div className='userlogo'>
                                        <img src={`${telecallerImage.whatsapp}`} alt="wp" />
                                        <span className='logo-text' onClick={sendWpMessage}>SEND MESSAGE</span>
                                    </div>
                                    <div className='userlogo'>
                                        <img src={`${telecallerImage.downloadimg}`} alt="download" />
                                        <span className='logo-text' onClick={downloadFiles}>DOWNLOAD FILES</span>
                                    </div>
                                </div>
                            }

                            {showRegCCButtons &&
                                <div className='icons'>
                                    <div className='userlogo'>
                                        <img src={`${telecallerImage.whatsapp}`} alt="wp" />
                                        <span className='logo-text' onClick={sendWpMessageRgCC}>SEND MESSAGE</span>
                                    </div>
                                    <div className='userlogo'>
                                        <img src={`${telecallerImage.downloadimg}`} alt="download" />
                                        <span className='logo-text' onClick={downloadFilesRgCC}>DOWNLOAD FILES</span>
                                    </div>
                                </div>
                            }
                        </div>


                        <form action="" onSubmit={SubmitNumber(GetData)}>
                            <div className='number-input'>

                                <div className='input-header'>
                                    {userType == "capital_markets" ?
                                        <label className='input-title'>Mobile number or Reference No.<span style={{ color: "red" }}>*</span></label>
                                        :
                                        <label className='input-title'>Reference No.<span style={{ color: "red" }}>*</span></label>}
                                    <div className='text-input'>
                                        <input
                                            type="text"
                                            placeholder="Enter here"
                                            onInput={(e) => {
                                                allTrim(e);
                                                setNoData("");
                                                setTable({ lead: false, pack: false })
                                            }}
                                            {...regesterNumber("number")}

                                            autoComplete="off"
                                            maxLength={20}
                                        />
                                        {numberError.number && <span><img src={`${telecallerImage.worning}`} alt='' />{numberError.number.message}</span>}
                                        {/* <span>{numberError.number?.message}</span> */}
                                    </div>
                                </div>

                                <div className='get-button'>

                                    <button disabled={isButtonDisabled}>

                                        {loaderMain.get ? (
                                            <div className="tele-loader">
                                                <RoundLoader />
                                            </div>
                                        ) : (
                                            <> <img src={`${telecallerImage.serch}`} alt="serch" />GET DETAILS</>
                                        )}</button>
                                </div>
                            </div>
                        </form>
                        {loader ? (
                            <div className="loader-alignment">
                                <Loader />
                            </div>
                        ) : (
                            <div>
                                {noData ? (
                                    <div className="no-data-found">
                                        <h2>{noData}</h2>
                                    </div>
                                ) : (
                                    <>
                                        {table.lead ? (

                                            <div>
                                                <div className='rejection lead'>

                                                    <div className="title-section lead-section">
                                                        <h2 className="card-title">Lead Details</h2>
                                                        <div className='status'>
                                                            <img src={`${telecallerImage.status}`} alt="filter" />
                                                            <span className='status-text'>Application Status : In Progress</span>
                                                        </div>
                                                    </div>
                                                    <div className='client-datils lead-details'>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.name}`} alt="name" />
                                                            <div className='card-detail'>
                                                                <h2>Customer Name</h2>
                                                                <span>{clientDetails.cName}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.pan}`} alt="pan" />
                                                            <div className='card-detail'>
                                                                <h2>PAN Number</h2>
                                                                <span>{maskNumber(clientDetails.pan)}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.date}`} alt="date" />
                                                            <div className='card-detail'>
                                                                <h2>Creation Date</h2>
                                                                <span>{clientDetails.cDate}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.leadIdUp}`} alt="leadIdUp" />
                                                            <div className='card-detail'>
                                                                <h2>Lead ID</h2>
                                                                <span>{clientDetails.id}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.leadCategory}`} alt="leadCategory" />
                                                            <div className='card-detail'>
                                                                <h2>Lead Category</h2>
                                                                <span>{clientDetails.leadCategory}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.leadSo}`} alt="leadSo" />
                                                            <div className='card-detail'>
                                                                <h2>Lead Source</h2>
                                                                <span>{clientDetails.utmSource}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.mobile}`} alt="mobile" />
                                                            <div className='card-detail'>
                                                                <h2>Mobile Number</h2>
                                                                <span>{maskNumber(clientDetails.mobile)}</span>
                                                            </div>
                                                        </div>


                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.resumedate}`} alt="resumedate" />
                                                            <div className='card-detail'>
                                                                <h2>Resume Date</h2>
                                                                <span>{clientDetails.resumeDate}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.score}`} alt="score" />
                                                            <div className='card-detail'>
                                                                <h2>Lead Score</h2>
                                                                <span>{clientDetails.leadScore}</span>
                                                            </div>
                                                        </div>
                                                        <div className='details-section'>
                                                            <img src={`${telecallerImage.city}`} alt="city" />
                                                            <div className='card-detail'>
                                                                <h2>City</h2>
                                                                <span>{clientDetails.city}</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className='edit-app'>
                                                    <div className='edit-button' onClick={editApplication}>
                                                        <button className='btn-text'><img src={`${telecallerImage.edit}`} alt="edit" />EDIT APPLICATION</button>
                                                    </div>
                                                </div>

                                                {(clientDetails.emailId && localStorage.getItem("TelecallerRole").toLowerCase() == "admin") &&
                                                    <div className='rejection lead'
                                                    // disable-fields
                                                    >

                                                        <div className="title-section lead-section lead-dash">
                                                            <h2 className="card-title">Update Lead Details</h2>
                                                        </div>
                                                        <div className='client-datils update-table'>

                                                            <div className={`${documentVal.digilocker ? 'update-section' : 'update-section disable-fields'}`}>
                                                                <form action="" onSubmit={handleSubmitGender(updateGender)}>
                                                                    <div className='update-wraper'>
                                                                        <div className='update-header'>
                                                                            <img src={`${telecallerImage.gander}`} alt="name" height={"25px"} width={"25px"} />
                                                                            <h2>Gender</h2>
                                                                        </div>
                                                                        <span className='exist-text'>{clientDetails.genderView}</span>
                                                                        <div className='numberInput '>
                                                                            <select className='genderSelect' {...registerGender("gender")}>
                                                                                <option value="">Choose gender</option>
                                                                                <option value="Male">Male</option>
                                                                                <option value="Female">Female</option>
                                                                            </select>
                                                                            {genderErrors.gender && <span className="invalid-feedback">{genderErrors.gender.message}</span>}
                                                                        </div>
                                                                        <button className='btn-update'>
                                                                            {loaderMain.gender ? (
                                                                                <div className="tele-loader">
                                                                                    <RoundLoader />
                                                                                </div>
                                                                            ) : (
                                                                                "UPDATE GENDER"
                                                                            )}</button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            <div className={`${documentVal.digilocker ? 'update-section' : 'update-section disable-fields'}`}>
                                                                <form action="" onSubmit={handleSubmitFname(updateFname)}>
                                                                    <div className='update-wraper'>
                                                                        <div className='update-header'>
                                                                            <img src={`${telecallerImage.fname}`} alt="name" height={"25px"} width={"25px"} />
                                                                            <h2>Father Name</h2>
                                                                        </div>
                                                                        {/* <span className='exist-text'>{clientDetails.fatherName}</span> */}
                                                                        <input className='email-value'
                                                                            value={clientDetails.fatherName}
                                                                            readOnly
                                                                        />
                                                                        <div className='update-input'>
                                                                            <input type="text"
                                                                                placeholder="Enter father name"
                                                                                onInput={(e) => {
                                                                                    nameFirstLetter(e);
                                                                                    startTrimString(e);
                                                                                }}
                                                                                {...registerFname("fname")}
                                                                            />
                                                                            {fnameErrors.fname && <span className="invalid-feedback">{fnameErrors.fname.message}</span>}
                                                                        </div>
                                                                        <button className='btn-update'>
                                                                            {loaderMain.fname ? (
                                                                                <div className="tele-loader">
                                                                                    <RoundLoader />
                                                                                </div>
                                                                            ) : (
                                                                                "UPDATE FATHER NAME"
                                                                            )}
                                                                        </button>
                                                                    </div>
                                                                </form>

                                                            </div>
                                                            <div className='update-section disable-fields'>
                                                                <form action="" onSubmit={handleSubmit(updateDob)}>
                                                                    <div className='update-wraper'>

                                                                        <div className='update-header'>
                                                                            <img src={`${telecallerImage.calender}`} alt="name" height={"25px"} width={"25px"} />
                                                                            <h2>Date of Birth</h2>
                                                                        </div>
                                                                        <span className='exist-text'>{clientDetails.dob}</span>
                                                                        <div className='update-input'>
                                                                            <input type="date"
                                                                                placeholder="DD/MM/YYYY"
                                                                                className={`datepicker form-control ${errors?.dob
                                                                                    ? "is-invalid"
                                                                                    : ""
                                                                                    }`}
                                                                                max={new Date(
                                                                                    new Date().setFullYear(
                                                                                        new Date().getFullYear() - 18
                                                                                    )
                                                                                ).toLocaleDateString("en-CA")}
                                                                                min={new Date(
                                                                                    new Date().setFullYear(
                                                                                        new Date().getFullYear() - 90
                                                                                    )
                                                                                ).toLocaleDateString("en-CA")}
                                                                                {...register("dob")}
                                                                            />
                                                                            {errors.dob && <span className="invalid-feedback">{errors.dob.message}</span>}
                                                                        </div>
                                                                        <button className='btn-update' type='submit'>
                                                                            {loaderMain.dob ? (
                                                                                <div className="tele-loader">
                                                                                    <RoundLoader />
                                                                                </div>
                                                                            ) : (
                                                                                " UPDATE DOB"
                                                                                //     <div className="tele-loader">
                                                                                //     <RoundLoader />
                                                                                // </div>
                                                                            )}
                                                                        </button>

                                                                    </div>
                                                                </form>

                                                            </div>
                                                            <div className='update-section disable-fields'>
                                                                <form action="" onSubmit={handleSubmitEmail(updateEmail)}>
                                                                    <div className='update-wraper'>
                                                                        <div className='update-header'>
                                                                            <img src={`${telecallerImage.email}`} alt="name" height={"25px"} width={"25px"} />
                                                                            <h2>E-mail Address</h2>
                                                                        </div>
                                                                        <input className='email-value'
                                                                            value={clientDetails.emailId}
                                                                            // defaultValue={"jhsfgjfgjsdgjgsdfsdjfgsjdfgsjgfsj"}
                                                                            readOnly
                                                                        />
                                                                        <div className='update-input'>
                                                                            <input type="text"
                                                                                placeholder="Enter new email address"
                                                                                {...registerEmail("email")}
                                                                                onInput={(e) => allTrim(e)}
                                                                                onPaste={(e) => e.preventDefault()}
                                                                                onChange={(e) => emailChange(e)}
                                                                            />
                                                                            {otpInput && <input type="text" placeholder='Email OTP'
                                                                                maxLength={4}
                                                                                onInput={(e) => { allTrim(e); EmailOtpValidation(e); emailVerification(e); }} />}
                                                                            {emailErrors.email && <span className="invalid-feedback">{emailErrors.email.message}</span>}

                                                                        </div>
                                                                        <button className='btn-update'>
                                                                            {loaderMain.email ? (
                                                                                <div className="tele-loader">
                                                                                    <RoundLoader />
                                                                                </div>
                                                                            ) : (
                                                                                "UPDATE E-MAIL"
                                                                            )}</button>
                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }


                                                {table.lead && localStorage.getItem("TelecallerRole").toLowerCase() == "admin" &&
                                                    (
                                                        documentVal.digilocker ||
                                                        documentVal.bav ||
                                                        documentVal.signature ||
                                                        documentVal.selfie
                                                    ) ? (
                                                    <div>
                                                        <div className='rejection lead'>
                                                            <div className="steps-section lead-section">
                                                                <div className="step-header">
                                                                    <h2 className="card-title" style={{ paddingBottom: "11px" }}>
                                                                        Step Deletion
                                                                    </h2>

                                                                    <div className="dropdown-container">
                                                                        <select
                                                                            className="genderSelect"
                                                                            style={{
                                                                                marginBottom: "14px",
                                                                                backgroundColor: "white",
                                                                                height: "33px",
                                                                                lineHeight: "31px",
                                                                                paddingTop: "0px",
                                                                                paddingBottom: "2px",
                                                                                verticalAlign: "middle"
                                                                            }}
                                                                            onChange={handleStepChange}
                                                                        >
                                                                            <option value="">Select Step</option>
                                                                            {documentVal.digilocker && <option value="Digilocker">Digilocker</option>}
                                                                            {documentVal.bav && <option value="BAV">BAV</option>}
                                                                            {documentVal.signature && <option value="Signature">Signature</option>}
                                                                            {documentVal.selfie && <option value="Selfie">Selfie</option>}
                                                                        </select>

                                                                        <span className="error-message-deletedocument">
                                                                            {documentTypeError && (
                                                                                <>
                                                                                    <img src={telecallerImage.worning} alt="" />
                                                                                    {documentTypeError}
                                                                                </>
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                                <div className='status'>
                                                                    <div className='delete-steps'>
                                                                        <div className='delete-button' onClick={deleteDocument}>
                                                                            <button className='btn-text'>
                                                                                <img src={`${telecallerImage.delete}`} alt="edit" />
                                                                                DELETE STEP
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                ) : null}
                                                {/* Datta added block for delete document @23-05-2026 end*/}


                                            </div>
                                        ) : null}
                                        {table.pack ? (
                                            <div>
                                                <PackUpdateNew clientDetails={clientDetails} />
                                            </div>
                                        ) : null}
                                    </>
                                )}
                            </div>
                        )}

                        <div className='rejection'>
                            <div className="title-section rejectionCard">
                                <h2 className="card-title">Rejection Dashboard</h2>
                                <div className='tablelogo' onClick={() => setFilterModal(true)}>
                                    <img src={`${telecallerImage.filter}`} alt="filter" height={"18px"} width={"18px"} />
                                    <h2>Filter</h2>
                                </div>

                            </div>
                            <div className='line'></div>
                            <div className='rejection-wraper'>
                                <CardComp imgList={`${telecallerImage.all}`}
                                    cardText={imgList[0].all}
                                    data={hgsData?.All}
                                />
                                <CardComp imgList={`${telecallerImage.monthly}`}
                                    cardText={imgList[0].monthly}
                                    data={hgsData?.Monthly}
                                    onBoxClick={handleBoxClick}
                                />
                                <CardComp imgList={`${telecallerImage.today}`}
                                    cardText={imgList[0].today}
                                    data={hgsData?.Today}
                                />
                            </div>
                        </div>
                        {/* <div> */}
                        {/* <button
                                value="excel"
                                onClick={(e) => handleOnClick(e.target.value)}
                                className="generate-button excel-btn"
                            >
                                {smallLoaderExcel ? (
                                    <div>
                                        <SmallLoader />
                                    </div>
                                ) : (
                                    <>
                                        <span className="icon-excelsvg"></span>
                                        {"Excel"}
                                    </>
                                )}
                            </button> */}
                        {hgsTable.submit &&
                            <div className="table-responsive scroll-table teledashtable mx-unset new-table">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Mobile No.</th>
                                            <th>Name</th>
                                            <th>Pack Amount</th>
                                            <th>KRA Status</th>
                                            <th>IPV Status</th>
                                            <th>Submitted On </th>
                                        </tr>
                                    </thead>
                                    <tbody
                                        // onScroll={(e) => handleScroll(e)}
                                        id="submitted-body"
                                    >
                                        {showTeleTableData(submittedData)}
                                    </tbody>

                                </table>
                            </div>
                        }
                        {hgsTable.reject &&
                            <div className="table-responsive scroll-table teledashtable mx-unset tele-edit new-table">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Mobile No.</th>
                                            <th>Name</th>
                                            <th>Pack Amount</th>
                                            <th>KRA Status</th>
                                            <th>IPV Status</th>
                                            <th>Submitted On </th>
                                            <th>Rejected On</th>
                                            <th>Rejected Reason</th>
                                            <th>Edit</th>
                                        </tr>
                                    </thead>

                                    <tbody
                                    //  onScroll={(e) => handleScroll(e)}
                                    >
                                        {RejectTableShow(rejectionData)}
                                    </tbody>
                                    {/* {scrollLoader && (
                                    <div className="loader-center">
                                        <LoaderForSearch />
                                    </div>
                                )} */}
                                </table>
                            </div>
                        }
                        {
                            hgsTable.activated &&
                            <div className="table-responsive scroll-table teledashtable mx-unset new-table">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Mobile No.</th>
                                            <th>Name</th>
                                            <th>Pack Amount</th>
                                            <th>KRA Status</th>
                                            <th>IPV Status</th>
                                            <th>Submitted On </th>
                                            <th>onl Id</th>
                                            <th>Account Activated</th>
                                        </tr>
                                    </thead>
                                    <tbody
                                    //    onScroll={(e) => handleScroll(e)}
                                    >
                                        {onlDataShow(createdData)}
                                    </tbody>
                                    {/* {scrollLoader && (
                            <div className="loader-center">
                              <LoaderForSearch />
                            </div>
                          )} */}
                                </table>
                            </div>
                        }
                        {/* </div> */}

                    </div>


                </div>

            </main>

            <Modal
                show={globalModal.modal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update {modalData}
                    </Modal.Title>
                    <button
                        type="button"
                        onClick={() => setGlobalModal({ modal: false, update: "", value: null })}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Are you sure want to Update {modalData}?
                    </h4>
                    <div className="btn-yes-no">
                        <Button className="yes-btn confirmation-btn" onClick={updateAll}>
                            Yes
                        </Button>
                        <Button
                            className="no-btn confirmation-btn"
                            onClick={() => setGlobalModal({ modal: false, update: "", value: null })}
                        >
                            No
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                // show={emailModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Change Email Address
                    </Modal.Title>
                    <button
                        type="button"
                        // onClick={() => setEmailModal(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        {/* Are you sure want to Change your Email ID:-({getEmaiId("email")}) */}
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                        // onClick={emailVerification}
                        >
                            Yes
                        </Button>
                        <Button
                            className="no-btn confirmation-btn"
                            closeButton
                        // onClick={() => {
                        //     setEmailModal(false);
                        //     setOtpVal("OTP", "");
                        // }}
                        >
                            No
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={existNumber}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <button
                        type="button"
                        onClick={() => setExistNumber(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Another Telecaller user is working on this application
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => setExistNumber(false)}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={aadherPan}
                onHide={() => setAadherPan(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
                    <button
                        type="button"
                        onClick={() => setAadherPan(false)}
                        className="btn-close filter-closeBtn"
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        “We regret to inform you that you will not be able to proceed ahead
                        as your PAN is not linked with your Aadhar. As per the new
                        regulatory guidelines it is mandatory to have your PAN linked with
                        Aadhar to carry out any financial transactions.{" "}
                        <a
                            target="_blank"
                            className="link_tag"
                            href="https://eportal.incometax.gov.in/iec/foservices/#/pre-login/bl-link-aadhaar"
                            rel="noreferrer"
                        >
                            Click here
                        </a>{" "}
                        to link your PAN with Aadhar now.”
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => setAadherPan(false)}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={session}
                onHide={() => setSession(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}
                className="popup rm-model session-expired"
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {/* Change Gender */}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4 className="section-title">
                        Session has been expired,Please Login again...
                    </h4>
                    <div className="btn-yes-no">
                        <Button
                            className="yes-btn confirmation-btn"
                            onClick={() => sessionExpired()}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                show={filterModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="rm-model filter-update-telecaller "
            >
                {/* <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                    </Modal.Title>
                    <button
                        type="button"
                        onClick={() => setFilterModal(false)}
                        className="btn-close filter-closeBtn "
                        aria-label="Close"
                    >
                        <span className="icon-close"></span>
                    </button>
                </Modal.Header> */}
                <Modal.Body>
                    <div className='close-button-modal'>
                        <button
                            type="button"
                            onClick={() => setFilterModal(false)}
                            className="btn-close filter-closeBtn "
                            aria-label="Close"
                        >
                            <span className="icon-close"></span>
                        </button>
                    </div>

                    <form action="" onSubmit={handleFilterSubmit(filterApplication)}>
                        <div className='filter'>
                            <div className='search'>
                                <label>Mobile No*</label>
                                <input type='text' placeholder='Mobile'
                                    {...regesterFilter("numberFilter")}
                                    onInput={(e) => {
                                        allTrim(e);
                                    }}
                                    maxLength={10}
                                />
                                {filterErrors.numberFilter && <span >{filterErrors.numberFilter.message}</span>}
                            </div>
                            <div className='options'>
                                <div className='filter-section'>
                                    <div className='numberInput'>
                                        <label>From date:</label>
                                        <input type='date'
                                            {...regesterFilter("fromDate")}
                                            max={CommonDate.getPreviousDay}
                                        />
                                        {filterErrors.fromDate && <span className="modalerror-filter">{filterErrors.fromDate.message}</span>}
                                    </div>
                                    <div className='numberInput'>
                                        <label>To date:</label>
                                        <input type='date'
                                            {...regesterFilter("toDate")}
                                            max={CommonDate.toDateMax}
                                        />
                                        {filterErrors.toDate && <span className="modalerror-filter">{filterErrors.toDate.message}</span>}
                                    </div>
                                </div>
                                <div className='filter-section'>
                                    <div className='numberInput'>
                                        <label>KRA Status</label>
                                        <select className='genderSelect font-gender'  {...regesterFilter("kraStatus")}>
                                            <option value="All">All</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                        {filterErrors.kraStatus && <span className="modalerror-filter">{filterErrors.kraStatus.message}</span>}
                                    </div>
                                    <div className='numberInput'>
                                        <label>Status</label>
                                        <select className='genderSelect'  {...regesterFilter("appStatus")}>
                                            <option value="Submitted">Submitted</option>
                                            <option value="Rejected">Rejected</option>
                                            <option value="onl">Account created</option>
                                        </select>
                                        {filterErrors.appStatus && <span className="modalerror-filter">{filterErrors.appStatus.message}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filter-btn">
                            <Button className="reset" onClick={() => resetModal()}>
                                RESET

                            </Button>
                            <Button
                                type='submit'
                                className="apply"
                            // closeButton
                            // onClick={() => setFilterModal(false)}
                            >
                                APPLY
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default TelecallerUpdated;